export default {"src":"/uk/_next/static/media/pastPerformanceIcon.9243fe4c.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};